import { render, staticRenderFns } from "./add-shipments.vue?vue&type=template&id=36834799&scoped=true"
import script from "./add-shipments.vue?vue&type=script&lang=js"
export * from "./add-shipments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36834799",
  null
  
)

export default component.exports